@defer (when chartData().length > 0) {
  <div
    class="donut-wrapper"
    id="donut-wrapper"
    role="img"
    [attr.aria-label]="chartAriaLabel()">
    <div class="donut" [style]="getStyleProperty()" aria-hidden="true">
      @for (item of ordinals(); track item) {
        @if (canShowSlice(item)) {
          <div class="donut__slice" [ngClass]="getSliceClass(item)"></div>
        }
      }
      <div class="donut__label">
        <div class="donut__label__heading">
          {{ totalCount() }}
        </div>
      </div>
    </div>

    <div class="donut__legend" aria-hidden="true">
      <div class="donut__legend__list">
        @for (status of statuses(); track status) {
          <p>
            <span class="donut_label_dot" [ngClass]="getLegendItemClass(status)"></span>
            <span class="donut_label__text">{{ getLegendText(status) }}</span> -
            <span>{{ getAmount(status) }}</span>
          </p>
        }
      </div>
    </div>
  </div>
}
